import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth, INVITE_KEY } from "@/hooks/useAuth";

// Shared by Google and email-code sign-in: finishes any invite, swap or sticker the visitor came in with
export const afterSignIn = async (u, { qc, setUser }) => {
  qc.clear();
  setUser(u);
  toast.success(`Welcome, ${u.name.split(" ")[0]}`);
  const first = (r) => r.name.split(" ")[0];
  const invite = localStorage.getItem(INVITE_KEY);
  localStorage.removeItem(INVITE_KEY);
  if (invite) {
    api.visitSignup({ token: invite, s: localStorage.getItem("bl_src") || "" });
    localStorage.removeItem("bl_src");
    const r = await api.requestByLink(invite).catch(() => null);
    if (r) toast.success(r.relation === "friend" ? `You and ${first(r)} are now friends` : `Friend request sent to ${first(r)}`);
  }
  const swap = localStorage.getItem("bl_swap");
  localStorage.removeItem("bl_swap");
  if (swap) {
    const r = await api.swapAccept(swap).catch(() => null);
    if (r) toast.success(`You and ${first(r)} are now friends`);
  }
  const tap = localStorage.getItem("bl_tap");
  localStorage.removeItem("bl_tap");
  if (tap) {
    const r = await api.tapRequest(tap).catch(() => null);
    if (r) toast.success(r.relation === "friend" ? `You and ${first(r)} are now friends` : `Friend request sent to ${first(r)}`);
  }
};

export const AuthCallback = () => {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    api.createSession(sessionId)
      .then((u) => afterSignIn(u, { qc, setUser }))
      .catch(() => { setUser(null); toast.error("Sign-in failed, please try again"); })
      .finally(() => navigate("/", { replace: true }));
  }, [navigate, qc, setUser]);

  return <div className="h-screen bg-[#0B0F17]" data-testid="auth-callback" />;
};
